"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  name: 'VxeIcon',
  props: {
    name: String,
    roll: Boolean
  },
  render: function render(h) {
    return h('i', {
      class: ["vxe-icon-".concat(this.name), this.roll ? 'roll' : ''],
      on: {
        click: this.clickEvent
      }
    });
  },
  methods: {
    clickEvent: function clickEvent(evnt) {
      this.$emit('click', {
        $event: evnt
      });
    }
  }
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/.store/vxe-table@3.7.6/~/vxe-table/lib/icon/src/icon.js
// module id = 985
// module chunks = 75